import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c6927a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-formsNavigation" }
const _hoisted_2 = { class: "sqg-formsNavigation__line" }
const _hoisted_3 = { class: "sqg-formsNavigation__line" }
const _hoisted_4 = {
  key: 0,
  class: "sqg-formsNavigation__loader"
}
const _hoisted_5 = {
  key: 1,
  class: "sqg-formsNavigation__results"
}
const _hoisted_6 = {
  key: 0,
  class: "sqg-formsNavigation__line"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "sqg-formsNavigation__noResults"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Aucun formulaire ...")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "sqg-formsNavigation__chart" }
const _hoisted_13 = { class: "sqg-formsNavigation__name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Formulaire :", -1))
const _hoisted_15 = { class: "sqg-formsNavigation__tags" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Propriétés :", -1))
const _hoisted_17 = {
  key: 0,
  class: "sqg-formsNavigation__tag -mandatory"
}
const _hoisted_18 = {
  key: 1,
  class: "sqg-formsNavigation__tag -optional"
}
const _hoisted_19 = {
  key: 2,
  class: "sqg-formsNavigation__tag -multiple"
}
const _hoisted_20 = {
  key: 3,
  class: "sqg-formsNavigation__tag -readOnly"
}
const _hoisted_21 = { class: "sqg-formsNavigation__actions" }

import { computed, ComputedRef, defineAsyncComponent, defineComponent, onMounted, ref } from "vue";
import Form from "@/types/Form";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import { useFoldersStore } from "@/stores/folders";
import { beautifyName } from "@/functions/forms";
import Chart from '@/components/Chart.vue';
import Loader from '@/components/Loader.vue';
import Input from '@/components/Input.vue';
import Card from '@/components/Card.vue';
import Header from '@/components/Header.vue';
import CardButton from '@/components/CardButton.vue';
import CardFilter from '@/components/CardFilter.vue';
import Initialisation from '@/forms/Initialisation.vue';
import Primes from '@/forms/Primes.vue';
import Bureautique from '@/forms/Bureautique.vue';
import Editions from '@/forms/Editions.vue';
import ProvisionComptable from '@/forms/ProvisionComptable.vue';
import FichierSequentiel from '@/forms/FichierSequentiel.vue';
import Masque from '@/forms/Masque.vue';
import Import from '@/forms/Import.vue';
import ActiviteJournaliere from '@/forms/ActiviteJournaliere.vue';
import {useRoute} from "vue-router";

//STORE folders

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const foldersStore = useFoldersStore();
const { currentFolder, folderLoader } = storeToRefs(foldersStore);

//STORE user
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

//DATA
const filtersType = ref<Array<String>>([]);
const searchTerm = ref('');
const formsList = ref([]);

const formsMandatory: ComputedRef<number> = computed(() => {
  return currentFolder.value.forms.filter((form: Form) => form.isMandatory).length;
});
const formsOptional: ComputedRef<number> = computed(() => {
  return currentFolder.value.forms.filter((form: Form) => !form.isMandatory).length;
});
const formsMultiple: ComputedRef<number> = computed(() => {
  return currentFolder.value.forms.filter((form: Form) => form.isMultiple).length;
});
const formsToDisplay: ComputedRef<Array<Form>> = computed(() => {
  let result = currentFolder.value.forms;
  if (filtersType.value.length > 0) {
    filtersType.value.forEach((filter: any) => {
      if (filter === 'mandatory') result = result.filter((form: Form) => form.isMandatory);
      if (filter === 'optional') result = result.filter((form: Form) => !form.isMandatory);
      if (filter === 'multiple') result = result.filter((form: Form) => form.isMultiple);
    });
  }
  if (searchTerm.value !== '') result = result.filter((form: Form) => form.formType.includes(searchTerm.value));
  return result.sort(dynamicSort('formType'));
});
const dynamicSort = (property: any) => {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return ((a: any, b: any) => {
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  });
}

const filterBy = (type: Array<String>) => {
  if (isActive(type)) {
    filtersType.value.splice(0,filtersType.value.length);
  } else {
    filtersType.value.splice(0,filtersType.value.length);
    type.forEach(elem => filtersType.value.push(elem));
  }
};
const isActive = (type: Array<String>) => {
  return type.every(elem => filtersType.value.includes(elem));
};

const formId = ref('');
const formToOpen = ref('');
const isReadOnly = ref(false);
const goToForm = ((form: Form) => {
  isReadOnly.value = form.formState === 'submitted';
  formId.value = form.id;
  formToOpen.value = form.formType;
});

const isSubmitAllowed: ComputedRef<Boolean> = computed(() => {
  return (currentFolder.value.forms.filter((form: Form) => form.isMandatory).filter((form: Form) => form.formState !== 'submitted')).length !== 0;
});

const percent = (state: string) => {
  if (state === 'virgin') return 0;
  if (state === 'draft') return 50;
  if (state === 'submitted') return 100;
}

const submitForms = () => {
  foldersStore.submitForms(currentFolder.value.id).then(() => {
    loadForms();
  });
};

//ROUTER
const route = useRoute();
const loadForms = () => {
  formToOpen.value = '';
  foldersStore.getFolderById(String(route.params.folderId));
}

onMounted(() => {
  loadForms();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      icone: "fas fa-align-center",
      title: "Configuration des formulaires",
      displayCurrentFolder: ""
    }),
    _createElementVNode("div", {
      class: _normalizeClass(['sqg-formsNavigation__board', {'-loading': _unref(folderLoader)}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(currentFolder).state === 'configuration')
          ? (_openBlock(), _createBlock(CardButton, {
              key: 0,
              width: "25",
              disabled: _unref(isSubmitAllowed),
              height: "96",
              class: "sqg-formsNavigation__submit clickable",
              icon: "fas fa-paper-plane",
              text: "Soumettre les formulaires",
              onClick: submitForms
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(folderLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 0,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(CardFilter, {
              key: 1,
              width: "100",
              height: "80",
              title: "Formulaires obligatoires",
              number: _unref(formsMandatory),
              icone: "fas fa-lock",
              isActive: isActive(['mandatory']),
              onFilter: _cache[0] || (_cache[0] = ($event: any) => (filterBy(['mandatory'])))
            }, null, 8, ["number", "isActive"])),
        (_unref(folderLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 2,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(CardFilter, {
              key: 3,
              width: "100",
              height: "80",
              title: "Formulaires facultatifs",
              number: _unref(formsOptional),
              icone: "fas fa-lock-open",
              isActive: isActive(['optional']),
              onFilter: _cache[1] || (_cache[1] = ($event: any) => (filterBy(['optional'])))
            }, null, 8, ["number", "isActive"])),
        (_unref(folderLoader))
          ? (_openBlock(), _createBlock(Card, {
              key: 4,
              width: "100",
              height: "48"
            }, {
              default: _withCtx(() => [
                _createVNode(Loader, { size: "36" })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(CardFilter, {
              key: 5,
              width: "100",
              height: "80",
              title: "Formulaires multiples",
              number: _unref(formsMultiple),
              icone: "fab fa-buffer",
              isActive: isActive(['multiple']),
              onFilter: _cache[2] || (_cache[2] = ($event: any) => (filterBy(['multiple'])))
            }, null, 8, ["number", "isActive"]))
      ]),
      (_unref(folderLoader))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(Loader, { msg: "Chargement de vos formulaires" })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(currentFolder).forms.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(Card, {
                    width: "100",
                    height: "40",
                    class: "sqg-formsNavigation__search"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(Input, {
                        type: "text",
                        placeholder: "Rechercher un formulaire ...",
                        modelValue: searchTerm.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTerm).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(formsToDisplay).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(formsToDisplay), (form, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "sqg-formsNavigation__form",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`sqg-formsNavigation__mark -${form.formState}`)
                    }, null, 2),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(Chart, {
                        percent: percent(form.formState),
                        text: percent(form.formState) + '%'
                      }, null, 8, ["percent", "text"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_unref(beautifyName)(form.formType)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      (form.isMandatory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Obligatoire"))
                        : _createCommentVNode("", true),
                      (!form.isMandatory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Facultatif"))
                        : _createCommentVNode("", true),
                      (form.isMultiple)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Multiple"))
                        : _createCommentVNode("", true),
                      (form.formState === 'submitted')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Lecture seule"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      (form.formState === 'submitted')
                        ? (_openBlock(), _createBlock(CardButton, {
                            key: 0,
                            icon: "fas fa-eye",
                            text: "Consulter",
                            small: "",
                            onClick: ($event: any) => (goToForm(form))
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(CardButton, {
                            key: 1,
                            icon: "fas fa-arrow-right",
                            text: "Remplir",
                            small: "",
                            onClick: ($event: any) => (goToForm(form))
                          }, null, 8, ["onClick"]))
                    ])
                  ]))
                }), 128))
          ]))
    ], 2),
    (formToOpen.value === 'initialisation')
      ? (_openBlock(), _createBlock(Initialisation, {
          key: 0,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[5] || (_cache[5] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'primes')
      ? (_openBlock(), _createBlock(Primes, {
          key: 1,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[7] || (_cache[7] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'editions')
      ? (_openBlock(), _createBlock(Editions, {
          key: 2,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[9] || (_cache[9] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'bureautique')
      ? (_openBlock(), _createBlock(Bureautique, {
          key: 3,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[11] || (_cache[11] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'provisionComptable')
      ? (_openBlock(), _createBlock(ProvisionComptable, {
          key: 4,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[13] || (_cache[13] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'fichierSequentiel')
      ? (_openBlock(), _createBlock(FichierSequentiel, {
          key: 5,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[15] || (_cache[15] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'import')
      ? (_openBlock(), _createBlock(Import, {
          key: 6,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[17] || (_cache[17] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'activiteJournaliere')
      ? (_openBlock(), _createBlock(ActiviteJournaliere, {
          key: 7,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[19] || (_cache[19] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true),
    (formToOpen.value === 'masque')
      ? (_openBlock(), _createBlock(Masque, {
          key: 8,
          class: "sqg-form",
          formId: formId.value,
          readOnly: isReadOnly.value,
          onClose: _cache[20] || (_cache[20] = ($event: any) => (formToOpen.value = '')),
          onSave: _cache[21] || (_cache[21] = ($event: any) => (loadForms()))
        }, null, 8, ["formId", "readOnly"]))
      : _createCommentVNode("", true)
  ]))
}
}

})